import { UrlUtils } from "../url";

const baseUrl = UrlUtils.trimEndSlash(appSettings["Integrations:SAG:BaseAddress"]);
const environment = UrlUtils.trimEndSlash(appSettings["Integrations:SAG:Environment"]);
const sagSubscriptionKey = appSettings["Integrations:SAG:SubscriptionKey"];

function getSagBasicApiUrl(apiName: string) {
    return UrlUtils.trimEndSlash(`${baseUrl}/${apiName}`);
}

function getSagApiUrl(apiName: string, version?: string): string {
    const segments = [getSagBasicApiUrl(apiName), environment, version].filter(Boolean);
    return segments.join("/") + "/";
}

function extractSagHost(url: string): string {
    if (!url) return "";
    try {
        return new URL(url).host.toLowerCase();
    } catch {
        return "";
    }
}

const sagHost = extractSagHost(baseUrl);

const REQUIRED_PROTOCOL = "https:";

const isSagUrl = (href: string): boolean => {
    if (!href || !sagHost) return false;
    try {
        const { protocol, host } = new URL(href);
        // Only accept HTTPS for secure communication with SAG API
        return protocol === REQUIRED_PROTOCOL && host.toLowerCase() === sagHost;
    } catch {
        return false;
    }
};

export function useSagOptions() {
    return {
        getSagApiUrl,
        getSagBasicApiUrl,
        sagSubscriptionKey,
        isSagUrl,
    };
}
